import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import { setPDFMode } from "../../hooks/usePDFShowHide";
import html2canvas from "html2canvas";
import {
  waitForPDFContent,
  waitForAPICallsToComplete,
} from "../../hooks/usePDFShowHide";

// CSS styles that only apply during PDF generation
const PDF_SPECIFIC_STYLES = `
  <style id="pdf-specific-styles">
    /* Global text wrapping for all elements */
    .pdf-mode * {
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* PDF-specific table input styling with text wrapping */
    .pdf-mode table input[type="text"],
    .pdf-mode table input[type="number"],
    .pdf-mode table input,
    .pdf-mode table textarea,
    .pdf-mode table select {
      min-height: 32px !important;
      height: auto !important;
      max-height: none !important;
      padding: 3px 8px !important;
      font-size: 13px !important;
      line-height: 1.4 !important;
      border: 1px solid #ccc !important;
      border-radius: 4px !important;
      width: 100% !important;
      box-sizing: border-box !important;
      background-color: white !important;
      color: #333 !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: clip !important;
      resize: none !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* All input fields outside tables should also wrap text */
    .pdf-mode input[type="text"],
    .pdf-mode input[type="number"],
    .pdf-mode input,
    .pdf-mode textarea,
    .pdf-mode select {
      min-height: 32px !important;
      height: auto !important;
      max-height: none !important;
      padding: 3px 8px !important;
      font-size: 13px !important;
      line-height: 1.4 !important;
      border: 1px solid #ccc !important;
      border-radius: 4px !important;
      width: 100% !important;
      box-sizing: border-box !important;
      background-color: white !important;
      color: #333 !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: clip !important;
      resize: none !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Select elements styling */
    .pdf-mode select {
      appearance: none !important;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
      background-image: none !important;
    }

    .pdf-mode .newreact__select__azilis {
      background-image: none !important;
      color: #333 !important;
    }

    /* Special handling for textarea elements */
    .pdf-mode textarea {
      min-height: 40px !important;
      height: auto !important;
      overflow-y: visible !important;
      white-space: pre-wrap !important;
    }

    /* Ensure table headers have proper text wrapping */
    .pdf-mode table th {
      padding: 10px 8px !important;
      font-weight: 600 !important;
      background-color: #f8f9fa !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      hyphens: auto !important;
      line-height: 1.4 !important;
      vertical-align: top !important;
      min-height: auto !important;
      height: auto !important;
      overflow-wrap: break-word !important;
      text-align: left !important;
      font-size: 13px !important;
      max-width: none !important;
    }

    /* Fix table body cells with text wrapping */
    .pdf-mode table td {
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: clip !important;
      vertical-align: top !important;
      line-height: 1.4 !important;
      min-height: 40px !important;
      height: auto !important;
      padding: 8px !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Ensure proper row height for wrapped content */
    .pdf-mode table tr {
      min-height: 44px !important;
      height: auto !important;
    }

    /* Form controls and custom components text wrapping */
    .pdf-mode .form-control,
    .pdf-mode .form-input,
    .pdf-mode .custom-input,
    .pdf-mode .input-wrapper {
      height: auto !important;
      min-height: 32px !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow: visible !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Labels and text elements */
    .pdf-mode label,
    .pdf-mode .form-label,
    .pdf-mode span,
    .pdf-mode div,
    .pdf-mode p {
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
      line-height: 1.4 !important;
    }

    /* Readonly inputs styling */
    .pdf-mode input[readonly],
    .pdf-mode textarea[readonly] {
      background-color: #f8f9fa !important;
      color: #495057 !important;
      border-color: #dee2e6 !important;
      height: auto !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Unit labels and addon text */
    .pdf-mode .input-group-text,
    .pdf-mode .unit-label {
      font-size: 12px !important;
      padding: 6px 8px !important;
      background-color: #e9ecef !important;
      border: 1px solid #ced4da !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Hide tooltips and popups */
    .pdf-mode .tooltip,
    .pdf-mode .popover,
    .pdf-mode .dropdown-menu {
      display: none !important;
    }

    /* Action buttons in tables */
    .pdf-mode table .btn,
    .pdf-mode table button {
      padding: 4px 8px !important;
      font-size: 12px !important;
      min-height: 28px !important;
      white-space: normal !important;
      word-wrap: break-word !important;
    }

    /* Table layout improvements */
    .pdf-mode table {
      table-layout: auto !important;
      width: 100% !important;
      border-collapse: collapse !important;
    }

    /* ENHANCED: Prevent page breaks inside important elements */
    .pdf-mode table,
    .pdf-mode .table-container,
    .pdf-mode .form-section,
    .pdf-mode .product-section,
    .pdf-mode .content-section,
    .pdf-mode .card,
    .pdf-mode .panel {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }

    .pdf-mode table th,
    .pdf-mode table td,
    .pdf-mode .form-group,
    .pdf-mode .input-group {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }

    /* ENHANCED: Force page breaks before major sections */
    .pdf-mode .page-break-before,
    .pdf-mode .new-section {
      page-break-before: always !important;
      break-before: page !important;
    }

    /* ENHANCED: Ensure sections have proper margins */
    .pdf-mode .section-separator {
      margin-top: 30px !important;
      margin-bottom: 20px !important;
      page-break-before: auto !important;
    }

    /* Handle long URLs or email addresses */
    .pdf-mode input[type="url"],
    .pdf-mode input[type="email"] {
      word-break: break-all !important;
      overflow-wrap: break-word !important;
    }

    /* NewProductDetail specific styling */
    .pdf-mode .newproductdetail,
    .pdf-mode .product-detail-header,
    .pdf-mode .product-detail-content {
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Ensure dropdowns show selected text properly */
    .pdf-mode .select-wrapper,
    .pdf-mode .select-container,
    .pdf-mode .dropdown-wrapper {
      height: auto !important;
      min-height: 32px !important;
      overflow: visible !important;
    }

    /* Custom select components */
    .pdf-mode .custom-select,
    .pdf-mode [class*="select-"] {
      height: auto !important;
      min-height: 32px !important;
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow: visible !important;
      padding: 6px 8px !important;
      border: 1px solid #ccc !important;
      background-color: white !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
    }

    /* Ensure all text content wraps properly */
    .pdf-mode h1, .pdf-mode h2, .pdf-mode h3, .pdf-mode h4, .pdf-mode h5, .pdf-mode h6 {
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      hyphens: auto !important;
      line-height: 1.3 !important;
    }

    /* Container adjustments */
    .pdf-mode .container,
    .pdf-mode .container-fluid {
      max-width: none !important;
      width: 100% !important;
    }

    /* Grid and flex adjustments */
    .pdf-mode .row,
    .pdf-mode .col,
    .pdf-mode [class*="col-"] {
      white-space: normal !important;
      word-wrap: break-word !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
    }

    /* Hide PDF controls and navigation elements */
    .pdf-mode .pdf-controls,
    .pdf-mode .sidebar,
    .pdf-mode .navigation,
    .pdf-mode .nav-sidebar {
      display: none !important;
    }

    /* Ensure proper spacing between sections */
    .pdf-mode .product-detail-section {
      margin-bottom: 20px !important;
      page-break-inside: avoid !important;
    }

    /* YFS Label specific styling */
    .pdf-mode .yfs-label-container,
    .pdf-mode .yfs-label-section {
      margin-top: 20px !important;
      page-break-inside: avoid !important;
    }
  </style>
`;

// Function to inject PDF-specific styles
const injectPDFStyles = () => {
  const existingStyles = document.getElementById("pdf-specific-styles");
  if (existingStyles) {
    existingStyles.remove();
  }

  document.head.insertAdjacentHTML("beforeend", PDF_SPECIFIC_STYLES);
  document.body.classList.add("pdf-mode");
  convertSelectElementsForPDF();
};

// Helper function to convert select elements to show selected text
const convertSelectElementsForPDF = () => {
  const selectElements = document.querySelectorAll(
    "table select, .pdf-mode select"
  );

  selectElements.forEach((select) => {
    if (select.selectedIndex >= 0) {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.text.trim()) {
        const textSpan = document.createElement("span");
        textSpan.className = "pdf-select-text";
        textSpan.style.cssText = `
          display: inline-block;
          width: 100%;
          min-height: 32px;
          padding: 6px 8px;
          font-size: 13px;
          line-height: 1.3;
          border: 1px solid #ccc;
          border-radius: 4px;
          background-color: white;
          color: #333;
          white-space: normal;
          word-wrap: break-word;
          box-sizing: border-box;
          vertical-align: top;
        `;
        textSpan.textContent = selectedOption.text;

        select.style.display = "none";
        select.parentNode.insertBefore(textSpan, select.nextSibling);
      }
    }
  });
};

// Function to remove PDF-specific styles
const removePDFStyles = () => {
  const pdfStyles = document.getElementById("pdf-specific-styles");
  if (pdfStyles) {
    pdfStyles.remove();
  }

  document.body.classList.remove("pdf-mode");
  cleanupSelectElements();
};

// Helper function to clean up converted select elements
const cleanupSelectElements = () => {
  const textSpans = document.querySelectorAll(".pdf-select-text");
  textSpans.forEach((span) => {
    span.remove();
  });

  const hiddenSelects = document.querySelectorAll(
    'select[style*="display: none"]'
  );
  hiddenSelects.forEach((select) => {
    select.style.display = "";
  });
};

// ENHANCED: Function to identify content sections that should not be split
const identifyContentSections = (element) => {
  const sections = [];

  // Common selectors for content sections that should stay together
  const sectionSelectors = [
    "table",
    ".table-container",
    ".form-section",
    ".product-section",
    ".content-section",
    ".card",
    ".panel",
    ".component-wrapper",
    '[class*="section"]',
    '[class*="component"]',
    ".row",
    "form",
    "fieldset",
  ];

  sectionSelectors.forEach((selector) => {
    const elements = element.querySelectorAll(selector);
    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const offsetTop = el.offsetTop;
      const height = el.offsetHeight;

      sections.push({
        element: el,
        offsetTop,
        height,
        bottom: offsetTop + height,
        selector,
      });
    });
  });

  // Sort sections by their vertical position
  return sections.sort((a, b) => a.offsetTop - b.offsetTop);
};

// ENHANCED: Function to calculate optimal page breaks
const calculatePageBreaks = (totalHeight, maxPageHeight, sections) => {
  const pageBreaks = [];
  let currentPageStart = 0;
  let currentPageEnd = maxPageHeight;

  while (currentPageStart < totalHeight) {
    // Find sections that would be split by this page break
    const conflictingSections = sections.filter(
      (section) =>
        section.offsetTop < currentPageEnd &&
        section.bottom > currentPageEnd &&
        section.height < maxPageHeight * 0.8 // Only avoid splitting if section is reasonable size
    );

    if (conflictingSections.length > 0) {
      // Find the earliest section that would be split
      const earliestConflict = conflictingSections.reduce((earliest, current) =>
        current.offsetTop < earliest.offsetTop ? current : earliest
      );

      // If moving the page break up would create a page that's too small,
      // move it down instead
      const adjustedPageEnd = earliestConflict.offsetTop;
      const pageHeight = adjustedPageEnd - currentPageStart;

      if (pageHeight < maxPageHeight * 0.3) {
        // Page would be too small, move to after the conflicting section
        currentPageEnd = earliestConflict.bottom;
      } else {
        // Move page break to before the conflicting section
        currentPageEnd = adjustedPageEnd;
      }
    }

    pageBreaks.push({
      start: currentPageStart,
      end: Math.min(currentPageEnd, totalHeight),
      height: Math.min(
        currentPageEnd - currentPageStart,
        totalHeight - currentPageStart
      ),
    });

    currentPageStart = currentPageEnd;
    currentPageEnd = currentPageStart + maxPageHeight;
  }

  return pageBreaks;
};

export const GeneratePagePDFProduct = async (options = {}) => {
  const {
    filename = "product-detail.pdf",
    onProgress = () => {},
    quality = 0.8,
    format = "a4",
    maxHeight = 2800, // Reduced to leave more room for content integrity
  } = options;

  try {
    onProgress("Preparing content for PDF...");

    setPDFMode(true);
    injectPDFStyles();

    onProgress("Waiting for components to expand...");
    await new Promise((resolve) => setTimeout(resolve, 2000));

    onProgress("Waiting for API calls to complete...");
    await waitForAPICallsToComplete(20000);

    onProgress("Waiting for tables to load data...");
    await new Promise((resolve) => setTimeout(resolve, 3000));

    onProgress("Verifying all content is ready...");
    try {
      await waitForPDFContent(25000);
    } catch (waitError) {
      console.warn("Timeout waiting for content, but proceeding:", waitError);
    }

    onProgress("Double-checking table content...");
    await waitForTableContent(10000);

    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    onProgress("Analyzing content structure...");

    const element = document.querySelector(".product__body") || document.body;

    element.style.display = "block";
    void element.offsetHeight;

    const totalHeight = element.scrollHeight;
    const totalWidth = Math.min(element.scrollWidth, 1400);

    // ENHANCED: Identify content sections
    const contentSections = identifyContentSections(element);

    // ENHANCED: Calculate optimal page breaks
    const pageBreaks = calculatePageBreaks(
      totalHeight,
      maxHeight,
      contentSections
    );

    onProgress(
      `Capturing content in ${pageBreaks.length} optimized sections...`
    );

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: format,
    });

    const pageWidth = format === "a4" ? 210 : 279;
    const pageHeight = format === "a4" ? 297 : 432;
    const margin = 10;
    const printableWidth = pageWidth - 2 * margin;
    const printableHeight = pageHeight - 2 * margin;

    let pageCount = 0;

    for (let i = 0; i < pageBreaks.length; i++) {
      const pageBreak = pageBreaks[i];
      const startY = pageBreak.start;
      const sectionHeight = pageBreak.height;

      onProgress(`Capturing section ${i + 1} of ${pageBreaks.length}...`);

      try {
        const tempContainer = document.createElement("div");
        tempContainer.style.position = "absolute";
        tempContainer.style.left = "-9999px";
        tempContainer.style.top = "0";
        tempContainer.style.width = totalWidth + "px";
        tempContainer.style.height = sectionHeight + "px";
        tempContainer.style.overflow = "hidden";
        tempContainer.style.backgroundColor = "#ffffff";

        tempContainer.classList.add("pdf-mode");

        const clonedContent = element.cloneNode(true);
        clonedContent.style.marginTop = -startY + "px";
        tempContainer.appendChild(clonedContent);

        document.body.appendChild(tempContainer);

        // Convert select elements in the cloned content
        const clonedSelects = tempContainer.querySelectorAll("select");
        clonedSelects.forEach((select) => {
          if (select.selectedIndex >= 0) {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption && selectedOption.text.trim()) {
              const textSpan = document.createElement("span");
              textSpan.className = "pdf-select-text";
              textSpan.style.cssText = `
                display: inline-block;
                width: 100%;
                min-height: 32px;
                padding: 6px 8px;
                font-size: 13px;
                line-height: 1.3;
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: white;
                color: #333;
                white-space: normal;
                word-wrap: break-word;
                box-sizing: border-box;
                vertical-align: top;
              `;
              textSpan.textContent = selectedOption.text;
              select.style.display = "none";
              select.parentNode.insertBefore(textSpan, select.nextSibling);
            }
          }
        });

        await new Promise((resolve) => setTimeout(resolve, 200));

        const dataUrl = await domtoimage.toPng(tempContainer, {
          quality: quality,
          bgcolor: "#ffffff",
          width: totalWidth,
          height: sectionHeight,
          style: {
            transform: "scale(1)",
            transformOrigin: "top left",
          },
          filter: (node) => {
            if (
              node.classList?.contains("no-pdf") ||
              node.classList?.contains("pdf-controls")
            ) {
              return false;
            }
            return true;
          },
        });

        document.body.removeChild(tempContainer);

        onProgress(`Processing section ${i + 1}...`);

        const img = new Image();
        img.src = dataUrl;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        const scale = printableWidth / ((totalWidth / 96) * 25.4);
        const scaledHeight = (sectionHeight / 96) * 25.4 * scale;

        // ENHANCED: Better page handling - avoid splitting single sections
        if (scaledHeight <= printableHeight) {
          // Section fits in one page
          if (pageCount > 0) {
            pdf.addPage();
          }

          pdf.addImage(
            dataUrl,
            "PNG",
            margin,
            margin,
            printableWidth,
            scaledHeight
          );

          pageCount++;
        } else {
          // Section is larger than one page - split it carefully
          let currentY = 0;
          let sectionPageCount = 0;

          while (currentY < scaledHeight) {
            if (pageCount > 0 || sectionPageCount > 0) {
              pdf.addPage();
            }

            pdf.addImage(
              dataUrl,
              "PNG",
              margin,
              margin - currentY,
              printableWidth,
              scaledHeight
            );

            currentY += printableHeight;
            sectionPageCount++;
            pageCount++;
          }
        }

        if (window.gc) {
          window.gc();
        }

        await new Promise((resolve) => setTimeout(resolve, 100));
      } catch (sectionError) {
        console.error(`Error capturing section ${i + 1}:`, sectionError);
      }
    }

    onProgress("Finalizing PDF...");
    pdf.save(filename);

    return { success: true, pageCount };
  } catch (error) {
    console.error("PDF generation failed:", error);
    return { success: false, error: error.message };
  } finally {
    setPDFMode(false);
    removePDFStyles();
  }
};

export const GeneratePagePDFProductAlternative = async (options = {}) => {
  const {
    filename = "product-detail.pdf",
    onProgress = () => {},
    quality = 0.8,
    format = "a4",
  } = options;

  try {
    if (typeof html2canvas === "undefined") {
      throw new Error(
        "html2canvas is required for this method. Please include it in your project."
      );
    }

    onProgress("Preparing content for PDF...");
    setPDFMode(true);
    injectPDFStyles();

    onProgress("Waiting for components to expand...");
    await new Promise((resolve) => setTimeout(resolve, 2000));

    onProgress("Waiting for API calls to complete...");
    await waitForAPICallsToComplete(20000);

    onProgress("Waiting for tables to load data...");
    await new Promise((resolve) => setTimeout(resolve, 3000));

    onProgress("Verifying all content is ready...");
    try {
      await waitForPDFContent(25000);
    } catch (waitError) {
      console.warn("Timeout waiting for content, but proceeding:", waitError);
    }

    onProgress("Double-checking table content...");
    await waitForTableContent(10000);

    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    const element = document.querySelector(".product__body") || document.body;

    // ENHANCED: Identify content sections for better page breaks
    const contentSections = identifyContentSections(element);

    onProgress("Capturing with html2canvas...");

    const canvas = await html2canvas(element, {
      scale: quality,
      useCORS: true,
      backgroundColor: "#ffffff",
      height: element.scrollHeight,
      width: Math.min(element.scrollWidth, 1600),
      onclone: (clonedDoc) => {
        clonedDoc.body.classList.add("pdf-mode");
        clonedDoc.head.insertAdjacentHTML("beforeend", PDF_SPECIFIC_STYLES);

        const elementsToRemove = clonedDoc.querySelectorAll(
          ".no-pdf, .pdf-controls"
        );
        elementsToRemove.forEach((el) => el.remove());

        const clonedSelects = clonedDoc.querySelectorAll("select");
        clonedSelects.forEach((select) => {
          if (select.selectedIndex >= 0) {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption && selectedOption.text.trim()) {
              const textSpan = clonedDoc.createElement("span");
              textSpan.className = "pdf-select-text";
              textSpan.style.cssText = `
                display: inline-block;
                width: 100%;
                min-height: 32px;
                padding: 6px 8px;
                font-size: 13px;
                line-height: 1.3;
                border: 1px solid #ccc;
                border-radius: 4px;
                background-color: white;
                color: #333;
                white-space: normal;
                word-wrap: break-word;
                box-sizing: border-box;
                vertical-align: top;
              `;
              textSpan.textContent = selectedOption.text;
              select.style.display = "none";
              select.parentNode.insertBefore(textSpan, select.nextSibling);
            }
          }
        });
      },
    });

    onProgress("Converting to PDF with smart page breaks...");

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: format,
    });

    const pageWidth = format === "a4" ? 210 : 279;
    const pageHeight = format === "a4" ? 297 : 432;
    const margin = 10;
    const printableWidth = pageWidth - 2 * margin;
    const printableHeight = pageHeight - 2 * margin;

    const imgWidth = printableWidth;
    const imgHeight = (canvas.height * printableWidth) / canvas.width;

    // ENHANCED: Calculate smart page breaks based on content sections
    const pixelsPerMM = canvas.height / imgHeight;
    const printableHeightPx = printableHeight * pixelsPerMM;

    const smartPageBreaks = calculatePageBreaks(
      canvas.height,
      printableHeightPx,
      contentSections.map((section) => ({
        ...section,
        offsetTop: (section.offsetTop / element.scrollHeight) * canvas.height,
        height: (section.height / element.scrollHeight) * canvas.height,
        bottom:
          ((section.offsetTop + section.height) / element.scrollHeight) *
          canvas.height,
      }))
    );

    let pageCount = 1;

    // Add first page
    pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);

    // Add subsequent pages based on smart breaks
    for (let i = 1; i < smartPageBreaks.length; i++) {
      const pageBreak = smartPageBreaks[i];
      const position = -(pageBreak.start / pixelsPerMM) + margin;

      pdf.addPage();
      pageCount++;
      onProgress(`Adding page ${pageCount}...`);

      pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
    }

    pdf.save(filename);
    return { success: true, pageCount };
  } catch (error) {
    console.error("PDF generation failed:", error);
    return { success: false, error: error.message };
  } finally {
    setPDFMode(false);
    removePDFStyles();
  }
};

// Additional helper function to specifically wait for table content
const waitForTableContent = async (timeout = 10000) => {
  return new Promise((resolve) => {
    const startTime = Date.now();

    const checkTables = () => {
      const tables = document.querySelectorAll("table");
      let allTablesReady = true;

      tables.forEach((table) => {
        const tbody = table.querySelector("tbody");
        if (tbody) {
          const rows = tbody.querySelectorAll("tr");
          const hasDataRows = Array.from(rows).some((row) => {
            const cells = row.querySelectorAll("td");
            return (
              cells.length > 0 &&
              Array.from(cells).some((cell) => {
                const text = cell.textContent.trim();
                return (
                  text !== "" &&
                  !text.includes("No data") &&
                  !text.includes("Loading") &&
                  !text.includes("...") &&
                  text !== "-"
                );
              })
            );
          });

          // If this table should have data but doesn't, mark as not ready
          const tableContainer = table.closest(
            '[class*="table"], [class*="component"]'
          );
          if (tableContainer && !hasDataRows) {
            // Check if there are any loading indicators
            const hasLoadingIndicators = table.querySelector(
              '.loading, .spinner, [data-loading="true"]'
            );
            if (!hasLoadingIndicators) {
              // Table might be empty legitimately, but let's wait a bit more
              allTablesReady = false;
            }
          }
        }
      });

      if (allTablesReady || Date.now() - startTime > timeout) {
        resolve();
      } else {
        setTimeout(checkTables, 500);
      }
    };

    checkTables();
  });
};
